function executeHiddenYandexCaptcha(item) {
	return new Promise((resolve, reject) => {
		if (!window.smartCaptcha) {
			return;
		}

		item.dataset.widgetId = window.smartCaptcha.render(item, {
			sitekey: item.dataset.sitekey,
			hl: item.dataset.hl || 'ru',
			invisible: true,
			callback: () => resolve()
		});

		window.smartCaptcha.execute(item.dataset.widgetId);
	});
}

function initHiddenYandexCaptcha(form) {
	return new Promise((resolve, reject) => {
		let smartCaptcha = form.querySelector('.smart-captcha-hidden');
		if (!smartCaptcha) {
			return resolve();
		}

		if (document.getElementById('smartcaptcha')) {
			executeHiddenYandexCaptcha(smartCaptcha).then(() => resolve());
			return;
		}

		let script = document.createElement('script');

		script.setAttribute('src', `https://smartcaptcha.cloud.yandex.ru/captcha.js`);
		script.setAttribute('id', 'smartcaptcha');
		script.async = true;
		script.defer = true;
		script.onload = () => {
			executeHiddenYandexCaptcha(smartCaptcha).then(() => resolve());
		};

		document.head.appendChild(script);
	});
}

function resetInitedYandexCaptcha(form) {
	[...form.querySelectorAll('.smart-captcha[data-widget-id], .smart-captcha-hidden[data-widget-id]')]
		.forEach(function (w) {
			window.smartCaptcha.reset(w.dataset.widgetId);
		});
}

export {initHiddenYandexCaptcha, resetInitedYandexCaptcha};
